// 全局断网提示横幅：核心逻辑（offline/online 事件 + 置顶横幅样式）已下沉
// web/shared/components/OfflineBanner（FE2-013/FE2-003 注入式首落地）。
// customer 原实现仅断网文案一行走 i18n，由本壳用 useTranslation 解析后经
// message props 注入（shared 不依赖 react-i18next）；渲染行为与下沉前逐字节等价。
import { useTranslation } from 'react-i18next';
import SharedOfflineBanner from '@shared/components/OfflineBanner';

export default function OfflineBanner() {
  const { t } = useTranslation();
  return <SharedOfflineBanner message={t('errors.network.offlineBanner')} />;
}
